import React from "react";
import { SpinningSun } from "../SpinningSun";

type Props = {
    minHeight: number;
};

export const LoadingWrapper: React.FC<Props> = ({ minHeight }) => {
    return (
        <div style={{ minHeight: `${minHeight.toString()}px` }}>
            <SpinningSun size={minHeight > 44 ? 44 : minHeight} />
        </div>
    );
};
